import React from 'react';
import { TextField } from '@biq/apex-ui';
import { Controller } from 'react-hook-form';

interface MultilineTextFieldProps {
    control: any;
    name: string;
    label: string;
    helperText?: string;
    onChange?: () => void;
    error?: boolean;
    errorText?: string;
}

export const MultilineTextField = ({
    control,
    name,
    label,
    helperText,
    onChange,
    error,
    errorText,
}: MultilineTextFieldProps): React.JSX.Element => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }): React.JSX.Element => (
                <TextField
                    {...field}
                    variant='outlined'
                    label={label}
                    multiline
                    rows={3}
                    helperText={helperText}
                    error={error}
                    errorText={errorText}
                    onChange={(value): void => {
                        field.onChange(value);
                        onChange?.();
                    }}
                />
            )}
        />
    );
};
